import React from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton, makeStyles } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1300
  },
  card: {
    position: 'relative',
    backgroundColor: 'white',
    borderRadius: 24,
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
    padding: 0,
    maxWidth: '90vw',
    maxHeight: '90vh',
    overflow: 'auto',
    // Custom scrollbar styling
    scrollbarWidth: 'thin',
    scrollbarColor: '#512EAB26 transparent',
    '&::-webkit-scrollbar': {
      width: 6,
      background: 'transparent'
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#512EAB26',
      borderRadius: 3,
      border: 'none'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#512EAB40'
    },
    '&::-webkit-scrollbar-button': {
      display: 'none'
    },
    '&::-webkit-scrollbar-corner': {
      background: 'transparent'
    }
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  content: {
    minHeight: '100%'
  }
}));

const PopupCard = ({
  open,
  onClose,
  children,
  width,
  height,
  maxWidth,
  maxHeight,
  className = '',
  showCloseButton = true,
  closeOnOverlayClick = true,
  ...props
}) => {
  const classes = useStyles();

  if (!open) return null;

  const handleOverlayClick = (event) => {
    if (closeOnOverlayClick && event.target === event.currentTarget) {
      onClose();
    }
  };

  const cardStyle = {
    width,
    height,
    maxWidth: maxWidth || '90vw',
    maxHeight: maxHeight || '90vh'
  };

  return (
    <Box className={classes.overlay} onClick={handleOverlayClick}>
      <Box
        className={`${classes.card} ${className}`}
        style={cardStyle}
        {...props}
      >
        {showCloseButton && (
          <IconButton
            className={classes.closeButton}
            onClick={onClose}
            size="small"
            aria-label="close"
          >
            <CloseIcon fontSize="small" style={{ color: '#171717' }} />
          </IconButton>
        )}
        <Box className={classes.content}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

PopupCard.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  showCloseButton: PropTypes.bool,
  closeOnOverlayClick: PropTypes.bool
};

PopupCard.defaultProps = {
  width: 'auto',
  height: 'auto',
  maxWidth: '90vw',
  maxHeight: '90vh',
  className: '',
  showCloseButton: true,
  closeOnOverlayClick: true
};

export default PopupCard;
